var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1433",
    viewBox: "0 0 24.374 35.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata1439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1437"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-203.5 -315.749)",
    "data-name": "Raggruppa 3693",
    id: "Raggruppa_3693"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#588157",
      fillOpacity: 1
    },
    transform: "translate(12307.5 11234.445)",
    "data-name": "Raggruppa 3637",
    id: "Raggruppa_3637"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#588157",
      fillOpacity: 1
    },
    transform: "translate(-12104 -10918.696)",
    id: "noun_Location_1578634"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#588157",
      fillOpacity: 1
    },
    fill: "#940000",
    transform: "translate(-24 -11.9)",
    d: "M36.187,11.9A12.208,12.208,0,0,0,24,24.087C24,30.8,36.187,47.4,36.187,47.4S48.374,30.8,48.374,24.087A12.208,12.208,0,0,0,36.187,11.9Zm0,18.487a6.3,6.3,0,1,1,6.3-6.3A6.281,6.281,0,0,1,36.187,30.387Z",
    "data-name": "Tracciato 3708",
    id: "Tracciato_3708"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#588157",
      fillOpacity: 1
    },
    fill: "#940000",
    transform: "translate(-12099 -10913.696)",
    r: 7,
    cy: 7,
    cx: 7,
    "data-name": "Ellisse 519",
    id: "Ellisse_519"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.67e0f65e96d65b581a6fd0a73b7c1a8c.svg";
export { ForwardRef as ReactComponent };